import classNames from 'classnames';
import { forwardRef } from 'react';
import { S as SvgIcon } from './SvgIcon-zgkXaGhD.js';
import createUseStyles from './create/index.js';
import { j as jsxRuntimeExports } from './jsx-runtime-KJzvSKZ_.js';

var useStyles = createUseStyles({
  goldIcon: {
    position: 'relative',
    display: 'inline-block',
    width: 24,
    height: 24,
    background: 'linear-gradient(189deg, rgba(250,187,0,1) 0%, rgba(208,56,141,1) 59.29%, rgba(154,26,137,1) 99.81%)',
    borderRadius: '50%',
    '& path': {
      fill: 'white'
    }
  },
  icon: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    height: '100%',
    transform: 'scale(0.65)'
  }
}, {
  name: 'gradient-input'
});

function GoldIcon(_ref, ref) {
  var className = _ref.className;
  var styles = useStyles();
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", {
    className: classNames(className, styles.goldIcon),
    ref: ref,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(SvgIcon, {
      name: "icon__gold__2__1",
      className: styles.icon
    })
  });
}
var GoldIcon$1 = /*#__PURE__*/forwardRef(GoldIcon);

export { GoldIcon$1 as G };
//# sourceMappingURL=GoldIcon-Kk2d0NTv.js.map
